import {
  DES_NM_DODA_CAREERJOBLIST_DETAIL_WITH_COUNT as DESCRIPTION_FORMAT_1PAGE,
  DES_NM_CAREERJOBLIST_DETAIL_2PAGE as DESCRIPTION_FORMAT_2PAGE,
} from '@doda/common/src/constants/seo';
import { formatString } from '@doda/common/src/utils/stringUtil';
import { addComma } from '@doda/common/src/utils/convNumberUtil';
import { getJobCountRange } from './getJobCountRange';

/** createDescription Props*/
interface Arguments {
  /** 表示中のページ数 */
  currentPage: number;
  /** 1ページあたりに表示する求人数 */
  displayJobCountPerPage: number;
  /** 資格名 */
  qualificationName: string;
  /** 地域や年収などのオプションテキスト */
  optionText: string;
  /** 求人数 */
  jobCount: number;
}

/**
 * metaタグのdescriptionテキストを生成する関数
 *
 * @param {Arguments} param - 関数の引数
 * @param {number} param.currentPage - 表示中のページ数
 * @param {number} param.displayJobCountPerPage - 1ページあたりに表示する求人数
 * @param {string} param.qualificationName - 資格名
 * @param {string} param.optionText - 地域や年収などのオプションテキスト
 * @param {number} param.jobCount - 求人数
 * @returns {string} descriptionテキスト
 */
export const createDescription = ({
  currentPage,
  displayJobCountPerPage,
  qualificationName,
  optionText,
  jobCount,
}: Arguments): string => {
  if (currentPage > 1) {
    const { first, last } = getJobCountRange(
      jobCount,
      currentPage,
      displayJobCountPerPage
    );
    return formatString(
      DESCRIPTION_FORMAT_2PAGE,
      [
        currentPage,
        first,
        last,
        qualificationName,
        optionText,
        currentPage,
        first,
        last,
      ].map(String)
    );
  }
  return formatString(
    DESCRIPTION_FORMAT_1PAGE,
    [qualificationName, optionText, addComma(jobCount)].map(String)
  );
};
